import React from 'react';
import {Grid} from 'semantic-ui-react'

const Footer = () => {
  return (
   <div>
        <div className='footerScss'>
        <Grid>
        <Grid.Column computer={8} mobile={16} >
            <div className='copyright'> ©bicci 2022 / Todos los derechos reservados</div>
         </Grid.Column >
        </Grid>
        </div>

  </div>
  );
};

export default Footer;
